<template>
    <div class="agreement_check">
        <div class="top_line"></div>
        <div class="check_box_bar flexMainXcenter">
            <div @click="checkHandle" class="check_box mgr6 flexShrink">
                <img v-if="!select" src="@/assets/images/login/select.png" alt="">
                <img v-else src="@/assets/images/login/selected.png" alt="">
            </div>
            同意
            <el-link class="agreement_link mglr4" :underline="false" :href="currentUrl + '#/privacyPage/agreement'" target="_blank">用户协议</el-link>
            和
            <el-link class="agreement_link mgl4" :underline="false" :href="currentUrl + '#/privacyPage/privacy'" target="_blank">隐私协议</el-link>
        </div>
    </div>
</template>

<script setup>
    import { ref,onMounted } from 'vue'
    import { useLoginStore } from './store'
    import { messageError } from '@/utils/message';
    import bus from '@/utils/bus'

    const loginStore = useLoginStore();
    const select = ref(false)
    const currentUrl = window.location.origin + window.location.pathname

    function checkHandle(){
        select.value = !select.value
        loginStore.changeAgreementCheck(select.value)
        bus.emit('agreement', select.value)
    }

    onMounted(()=> {
        bus.on('changeAgreement',()=> {   //on(收东西!!)
            console.log('执行')
            select.value = loginStore.agreementCheckOut
        })
        
    })

</script>

<style lang="scss" scoped>
    .agreement_check{
        padding: 0 32px;
        .top_line{
            height: 1px;
            background: #E5E6EB;
            margin-bottom:12px;
        }
        .check_box_bar{
            color: #86909C;
            font-family: PingFang SC;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            .check_box{
                width: 16px;
                height: 16px;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .agreement_link{
                position: relative;
                z-index: 9;
                --el-text-color-regular: #212429;
                font-family: PingFang SC;
                font-style: normal;
                --el-font-weight-primary: 400;
                --el-link-hover-text-color: #2A94FF;
                line-height: 20px; /* 142.857% */
            }
        }
    }
</style>